import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";


export const nisbetsCashbackViewRoute: RouteConfig<'with-page'> = {
    name: 'Nisbets Cashback',
    path: '/rewards/nisbets/cashback-deal',
    page: lazy(() => import('.')),
    flags: ['member-route'],
    context: 'member',
}